import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IconComponent } from '@app/components/shared/icon/icon.component';
import { BaseModalComponent } from '@app/components/shared/base-modal/base-modal.component';
import { IconName } from '@app/utils/enums/icon-enum';
import { ResponseModalData } from '@app/utils/interfaces/active-sessions-modal-detail.interface';
import { ResponseModalPayload } from '@app/utils/interfaces/response-modal-payload.interface';

@Component({
  selector: 'app-response-modal',
  standalone: true,
  imports: [IconComponent, TranslateModule, BaseModalComponent],
  templateUrl: './response-modal.component.html',
  styleUrl: './response-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResponseModalComponent {
  private readonly data = inject<ResponseModalData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<ResponseModalComponent>);

  public getConfigs(): ResponseModalPayload {
    if (!this.data.success) {
      return {
        iconName: IconName.FAILURE,
        titleKey: 'user-profile.activeSessions.response.failure.title',
        descriptionKey: 'user-profile.activeSessions.response.failure.description',
      };
    }

    const successKey = this.data.type === 'terminateAll' ? 'successAllSessions' : 'success';

    const baseKey = `user-profile.activeSessions.response.${successKey}`;

    return {
      iconName: IconName.SUCCESS,
      titleKey: `${baseKey}.title`,
      descriptionKey: `${baseKey}.description`,
    };
  }

  public close(): void {
    this.dialogRef.close();
  }
}
